import { Row, Col, Form, Input, InputNumber } from "antd";
import ImageUploadField from "components/fields/ImageUploadField";
import DatePickerField from "components/fields/DatePickerField";
import { useIntl } from "react-intl";
import TimezonePickerField from "components/fields/TimezonePickerField";
import { useMatch } from "react-router-dom";
import { ROUTE_PATHS } from "const/paths";
import { validateHtmlHeight } from "utils/htmlHeightValidator";

import EventDescriptionField from "./EventDescriptionField";
import RecurringSettingsField from "./RecurringSettingsField";
import SeatMapField from "./SeatMapField";
import PresalePasswordsField from "./PresalePasswordsField";

const EventInfo: React.FC = () => {
  const intl = useIntl();
  const isEditRoute = !!useMatch(ROUTE_PATHS.EventEdit);

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Event name",
          })}
          name={["input", "name"]}
          required
        >
          <Input disabled={isEditRoute ? false : undefined} />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Description",
          })}
          name={["input", "description"]}
        >
          <EventDescriptionField disabled={isEditRoute ? false : undefined} />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "PDF Ticket Description",
          })}
          rules={[validateHtmlHeight(220)]}
          name={["input", "ticketDescription"]}
        >
          <EventDescriptionField
            disabled={isEditRoute ? false : undefined}
            placeholder={intl.formatMessage({
              defaultMessage: "PDF Ticket Description",
            })}
          />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Timezone",
          })}
          name={["input", "timezone"]}
          required
        >
          <TimezonePickerField autodetect />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "First event date",
          })}
          name={["input", "date"]}
          required
        >
          <DatePickerField
            disabled={isEditRoute ? false : undefined}
            utc
            showTime
          />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Door Time",
          })}
          extra={intl.formatMessage({
            defaultMessage: "Number of hours before event time.",
          })}
          name={["input", "doorTime"]}
          required
        >
          <InputNumber precision={0} min={0} />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Age limit",
          })}
          name={["input", "ageLimit"]}
          required
        >
          <InputNumber precision={0} min={0} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Repeat",
          })}
          name={["input", "recurringSettings"]}
        >
          <RecurringSettingsField />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Publish first event at",
          })}
          name={["input", "publishAt"]}
          required
        >
          <DatePickerField
            disabled={isEditRoute ? false : undefined}
            utc
            showTime
          />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Date of sending tickets for first event",
          })}
          name={["input", "sendTicketsAt"]}
        >
          <DatePickerField utc showTime />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "YouTube URL",
          })}
          name={["input", "youtubeUrl"]}
        >
          <Input disabled={isEditRoute ? false : undefined} />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Image",
          })}
          name={["input", "image"]}
        >
          <ImageUploadField disabled={isEditRoute ? false : undefined} />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Seating Chart",
          })}
          name={["input", "seatMap"]}
        >
          <SeatMapField />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Presale Passwords",
          })}
          name={["input", "presalePasswords"]}
        >
          <PresalePasswordsField />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default EventInfo;
